import React, { useEffect } from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';
import { Disclosure } from '@headlessui/react';

const PlusIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="5" width="2" height="12" fill="#FFFFFF" />
    <rect
      y="7"
      width="2"
      height="12"
      transform="rotate(-90 0 7)"
      fill="#FFFFFF"
    />
  </svg>
);

const MinusIcon = () => (
  <svg
    width="12"
    height="2"
    viewBox="0 0 12 2"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      y="2"
      width="2"
      height="12"
      transform="rotate(-90 0 2)"
      fill="#FFFFFF"
    />
  </svg>
);

const faqItems = [
  {
    question: 'Як залучити курця?',
    answer: (
      <>
        <p>Щоб залучити курця, вам потрібно:</p>
        <ul>
          <li>переконатися, що курцю є 18 років;</li>
          <li>
            запропонувати повнолітньому курцю пройти опитування та надати йому
            QR-код;
          </li>
          <li>дочекатися проходження опитування.</li>
        </ul>
        <p>
          Після успішного проходження опитування вам нараховується винагорода.
        </p>
      </>
    )
  },
  {
    question: 'Як працює QR-код?',
    answer: (
      <>
        <p>
          QR-код можна використати лише один раз. Один повнолітній курець може
          пройти опитування лише за одним кодом.
        </p>
        <p>Щоб залучити нового курця, необхідно згенерувати новий QR-код.</p>
      </>
    )
  },
  {
    question: 'Чи отримують винагороду курці, яких залучають?',
    answer: (
      <p>
        Так, курці також отримують винагороду (у разі, якщо курець не проходив
        опитування раніше). За проходження опитування та підтвердження номера
        телефону їм нараховується 30 грн на мобільний рахунок.
      </p>
    )
  },
  {
    question: 'Яку винагороду я можу отримати?',
    answer: (
      <p>
        Нараховані бали можна обміняти на сертифікати або інші доступні
        винагороди в межах програми.
      </p>
    )
  },
  {
    question: 'За що я отримую бали?',
    answer: (
      <p>
        Бали нараховуються за виконання умов програми, а саме за успішне
        проходження опитування повнолітнім курцем, залученим через ваш QR-код.
      </p>
    )
  },
  {
    question: 'Чи є обмеження на використання балів?',
    answer: (
      <p>
        Так, бали можна обміняти на сертифікати в межах установленого ліміту —
        до 2100 грн на місяць. Обмін накопичених балів доступний до 01.04.2027
        включно.
      </p>
    )
  },
  {
    question:
      'Чи є обмеження на кількість сканувань і проходжень опитувальника?',
    answer: (
      <p>Так. Для одного учасника встановлено ліміт у 50 реєстрацій на добу.</p>
    )
  },
  {
    question: 'Коли нараховуються бали?',
    answer: (
      <p>
        Бали нараховуються одразу після підтвердження системою факту успішного
        проходження опитування.
      </p>
    )
  },
  {
    question: 'Чи можуть бути відхилені нараховані бали?',
    answer: (
      <>
        <p>Так, нараховані бали можуть бути відхилені у випадках:</p>
        <ul>
          <li>дублювання (якщо курець вже раніше проходив опитування)</li>
          <li>некоректних або фейкових реєстрацій</li>
        </ul>
        <p>У таких випадках бали не нараховуються.</p>
      </>
    )
  },
  {
    question: 'Що робити, якщо виникли питання?',
    answer: (
      <p>
        У разі виникнення питань ви можете залишити заявку на платформі, і наша
        команда зв’яжеться з вами, або зателефонувати вашому торговому
        представнику.
      </p>
    )
  }
];

const FaqComponent = ({ setScreenNumber, onQuestionClick }) => {
  useEffect(() => {
    const root = document.getElementById('root');
    if (root) root.scrollTop = 0;
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={styles.container}>
      <img
        src={getImageFromS3('/images/mgm/bg.png')}
        alt="background"
        className={styles.backgroundImage}
      />
      <div className={styles.content}>
        <div className={styles.header}>
          <svg
            width="20"
            height="18"
            viewBox="0 0 20 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={() => setScreenNumber(1)}
          >
            <path
              d="M4.29675 8.59375L9.66769 13.9647C10.261 14.5579 10.261 15.5198 9.66769 16.1131C9.07444 16.7063 8.11258 16.7063 7.51932 16.1131L0.707108 9.30086C0.316583 8.91033 0.316583 8.27717 0.707107 7.88664L7.51932 1.07443C8.11258 0.481175 9.07444 0.481175 9.66769 1.07443C10.261 1.66769 10.261 2.62955 9.66769 3.22281L4.29675 8.59375Z"
              fill="white"
            />
            <rect
              x="2.78076"
              y="6.99902"
              width="17"
              height="3"
              rx="1.5"
              fill="white"
            />
          </svg>
          <div onClick={onQuestionClick}>
            Є питання?
            <svg
              width="27"
              height="21"
              viewBox="0 0 27 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.86207 0C0.837931 0 0 0.821739 0 1.82609V16.4348L2.7931 13.6957H20.4828C21.5069 13.6957 22.3448 12.8739 22.3448 11.8696V1.82609C22.3448 0.821739 21.5069 0 20.4828 0H1.86207ZM23.2759 7.30435V11.8696C23.2759 13.4217 22.0655 14.6087 20.4828 14.6087H13.0345V16.4348C13.0345 17.4391 13.8724 18.2609 14.8966 18.2609H24.2069L27 21V9.13043C27 8.12609 26.1621 7.30435 25.1379 7.30435H23.2759Z"
                fill="white"
              />
            </svg>
          </div>
        </div>
        <h1>FAQ</h1>
        <div className={styles.list}>
          {faqItems.map((item, index) => (
            <Disclosure key={index}>
              {({ open }) => (
                <div className={styles.item}>
                  <Disclosure.Button className={styles.itemHeader}>
                    <span className={styles.question}>{item.question}</span>
                    {open ? <MinusIcon /> : <PlusIcon />}
                  </Disclosure.Button>
                  <Disclosure.Panel className={styles.answer} unmount={false}>
                    {item.answer}
                  </Disclosure.Panel>
                </div>
              )}
            </Disclosure>
          ))}
        </div>
        <div className={styles.footer}>
          <button onClick={() => setScreenNumber(2)}>Правила програм</button>
          <button
            onClick={() =>
              window.open(
                'https://www.pmiprivacy.com/ukraine/uk/consumer/',
                '_blank'
              )
            }
          >
            Політика конфіденційності
          </button>
          <button onClick={() => setScreenNumber(10)}>FAQ</button>
          <button onClick={() => setScreenNumber(11)}>
            Параметри застосування файлів cookie
          </button>
        </div>
      </div>
    </div>
  );
};

export default FaqComponent;
